import { MonthsYearsComponent } from "../../../_components/MonthsYearsComponent";
import { StreetAddressComponent } from "../../../_components/StreetAddressComponent";
import { IApplicationStep } from "../../../_store/application";
import { CityStateZip } from "../../../my-autoloan-shared/CityStateZip";
import { useRequiresPreviousAddress } from "../../../_store/useResidenceRequirements";

export const PrimaryPreviousAddress = (props: IApplicationStep) => {
  
  const primary_requires_previous = useRequiresPreviousAddress(
    (s) => s.primary_current_address
  );

  return (
    <>
      {primary_requires_previous && (
        <div className="group-box">
          <h2>Previous Address</h2>
          <div className="content">
            <div className="grid margin-responsive">
              <StreetAddressComponent
                label={"Street"}
                placeholder=""
                maxLength={50}
                store={(s) => s.primary_previous_address}
                step={props.step}
              />

              <CityStateZip
                store={(s) => s.primary_previous_address}
                step={props.step}
              />

              <MonthsYearsComponent
                label="How long did you live at this address?"
                errorMessage="Please select years and months at this address."
                store={(s) => s.primary_previous_address}
                step={props.step}
              ></MonthsYearsComponent>
            </div>
            <div className="info"></div>
          </div>
        </div>
      )}
    </>
  );
};
